const DEFAULT_SORT = { type: 'uploadTime', order: 'desc' };

/**
 * Scope an assets search body to a bulk product selection. Drops single-product
 * filters that would AND with productSelection, and replaces custom sort.
 */
export default function applyProductSelectionToSearchData(data, productSelection) {
  if (!productSelection) return data;

  const next = {
    ...data,
    productSelection,
  };

  delete next.productLayer;
  delete next.products;
  delete next.productVariantId;

  if (next.sort?.type === 'custom') {
    next.sort = DEFAULT_SORT;
  }

  return next;
}
